<template>
	<div ref="menuEl" class="btn_notification">
		<button type="button" class="notification_btn btn_toggle" aria-label="btn_toggle" @click="onToggleNotification">
			<IconNotification :icon-color="Boolean(route.query.isNotificationMenuOpen) ? '#ff5e00' : '#fff'" />
		</button>
		<DesktopNotification v-if="Boolean(route.query.isNotificationMenuOpen) && displayStore.isDesktop" />
	</div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { onClickOutside } from '@vueuse/core';

import IconNotification from '@/components/atom/icon/IconNotification.vue';
import DesktopNotification from '@/components/layout/header/NotificationMenu/DesktopNotification.vue';
import { useDisplayStore } from '@/stores/display';
import { closeMenuModal, openMenuModal } from '@/utils/function/modalMenu';

const displayStore = useDisplayStore();
const menuEl = ref();
const route = useRoute();
// -----function-----
//TODO: 알림창 토글 함수 state isOpen에 따라서 변경 필요
const onToggleNotification = () => {
	if (route.query.isNotificationMenuOpen) {
		closeMenuModal();
	} else {
		openMenuModal({ menu: `Notification` });
	}
};
// //외부 클릭 시 실행 함수
onClickOutside(menuEl, () => {
	if (route.query.isNotificationMenuOpen && displayStore.isDesktop) {
		closeMenuModal();
	}
});
</script>

<style lang="scss" scoped>
.btn_notification {
	position: relative;
}
</style>
